import { clerkAuthenticatedFetch } from "~/lib/clerk-authenticated-fetch";

/**
 * Start a provider OAuth flow without a full-page navigation to our /api/.../start
 * route. Full-page navigations on app.easygpt.builders trigger Clerk handshake
 * 307 loops (ERR_TOO_MANY_REDIRECTS). Bearer-authenticated fetch avoids that.
 */
export async function startOAuthWithClerk(startPathWithQuery: string): Promise<void> {
  const separator = startPathWithQuery.includes("?") ? "&" : "?";
  const url = `${startPathWithQuery}${separator}format=json`;

  const res = await clerkAuthenticatedFetch(url, {
    headers: { Accept: "application/json" },
  });

  const data = (await res.json().catch(() => null)) as {
    authorizeUrl?: string;
    error?: string;
  } | null;

  if (!res.ok || !data?.authorizeUrl) {
    throw new Error(data?.error || `OAuth start failed (${res.status})`);
  }

  window.location.href = data.authorizeUrl;
}
